import React, { memo, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { io } from 'socket.io-client';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

import AuthService from '../Services/AuthService';
import { SocketContextProvider } from '../Context/DashboardSocketContext';

import withAuth from '../Components/withAuth';
import AssetDetailsLayout from '../Components/Asset/AssetDetailsLayout';

export default withAuth(memo(AssetDetails));

const host = process.env['UI_SERVICE_HOST'],
  port = process.env['UI_SERVICE_PORT'],
  protocol = process.env['UI_SERVICE_PROTOCOL'];

function AssetDetails(props) {
  const { assetID } = useParams();

  const authService = useMemo(() => new AuthService(), []),
    token = useMemo(() => authService.getToken(), [authService]);

  const [socket, setSocket] = useState(),
    [socketConnectError, setSocketError] = useState('');

  useEffect(() => {
    if (socket?.connected) return;

    const auth = { gatewayID: assetID, token: `Bearer ${token}` },
      path = '/websocket',
      socketURL = `${protocol}://${host}:${port}/dashboard`,
      transports = ['polling', 'websocket'];

    const socketInstance = io(socketURL, { auth, path, transports })
      .on('connect', () => setSocket(socketInstance))
      .on('connect_error', (err) => {
        if (!authService.getToken()) return;

        setSocketError(err?.message);
        socketInstance?.disconnect?.();
      })
      .on('disconnect', (reason) => {
        if (reason === 'io server disconnect') socketInstance?.connect();
      })
      .on('error', (err) => {
        setSocketError(err?.message);
        socketInstance?.disconnect?.();
      });
    return () => {
      socketInstance?.disconnect?.();
    };
  }, [assetID, authService, socket?.connected, token]);

  return (
    <SocketContextProvider value={socket}>
      {socket ? (
        <AssetDetailsLayout
          {...props}
          socketConnectError={socketConnectError}
        />
      ) : (
        <div className="h-100 w-100 d-flex align-items-center justify-content-center">
          <FontAwesomeIcon
            color="var(--brand-primary)"
            icon={faCircleNotch}
            size="5x"
            spin
          />
        </div>
      )}
    </SocketContextProvider>
  );
}
